


















































































import {Component, Prop, Mixins} from 'vue-property-decorator';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import UpcomingEvent from '@/ts/instances/notifications/UpcomingEvent';
import DateMethods from '@/mixins/DateMethods.vue';

@Component({
    name: 'UpcomingNotification',
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            swiperOption: {
                direction: 'horizontal',
                slidesPerView: 'auto',
                freeMode: false,
                mousewheel: true,
            },
        };
    },
})
export default class UpcomingNotification extends Mixins(DateMethods) {
    constructor() {
        super();
    }

    get events(): UpcomingEvent[] {
        return this.$store.getters['TenantNotifications/getUpcomingEvents'].sort((a, b) => {
            return (this.$moment(a.startTime).unix() > this.$moment(b.startTime).unix()) ? 1 : -1;
        });
    }

    public show(event: UpcomingEvent): void {
        if (event.isBooking) {
            this.$router.push({
                name: 'shared-facilities',
                params: { bookingId: event.id.toString() },
                query: { bookingId: event.id.toString() },
            });
        }

        if (event.isEvent) {
            this.$router.push({
                name: 'event',
                params: { eventId: event.id.toString() },
                query: { notification: event.notificationId.toString() },
            });
        }
    }
}
